import React, { useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import Input from "../../comman/input";
import TextArea from "../../comman/textarea";
import auth from "../../services/authService";
import { getAlert } from "../../services/appAlerts";
import { uploadFileToBlob } from "../../services/blobUploadService";
import { updateTimeLogInvoice, uploadTimeLogInvoiceDocument } from "../../app/store/timeLogInvoice";

function UploadInvoice(props) {
  const [data, setData] = useState({});
  const [errors, setErrors] = useState({});
  const [documents, setDocuments] = useState([]);
  const [isDragging, setIsDragging] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const fileInputRef = useRef(null);
  const dispatch = useDispatch();

  const handleChange = ({ currentTarget: input }) => {
    setData((prev) => ({
      ...prev,
      [input.name]: input.value,
    }));

    if (errors[input.name]) {
      setErrors((prev) => {
        const next = { ...prev };
        delete next[input.name];
        return next;
      });
    }
  };

  const renderInput = (name, label, type = "text") => (
    <Input
      type={type}
      name={name}
      value={data[name] || ""}
      label={label}
      onChange={handleChange}
      error={errors[name]}
    />
  );

  const renderTextArea = (name, label) => (
    <TextArea
      name={name}
      value={data[name] || ""}
      label={label}
      onChange={handleChange}
      error={errors[name]}
    />
  );

  const doSubmit = async () => {
    const user = auth.getCurrentUser();
    const { wfTask: workflowTask, selectedObj, handleInvShowHide } = props;
    let docId = 0;

    if (documents.length > 0) {
      const frmData = new FormData();
      frmData.append("message", data["notes"] || "");
      frmData.append("workflowTask", JSON.stringify(workflowTask));
      frmData.append("userId", user.id);

      frmData.append(
        "files",
        JSON.stringify(
          documents.map((file) => {
            return {
              name: file.name,
              type: file.type,
              size: file.size,
            };
          })
        )
      );

      const result = await dispatch(uploadTimeLogInvoiceDocument(frmData));

      docId = result?.uploadId;

      if (docId > 0) {
        await Promise.all(
          documents.map((file, key) => {
            if (!file.file) return Promise.resolve();
            return uploadFileToBlob(
              file.file,
              result.sasUrls[key].uploadUrl,
              (progress) => {
                console.log(`Upload progress for ${file.name}: ${progress}%`);
              }
            );
          })
        );
      }
    }

    const tmObj = {
      id: selectedObj.id,
      invoiceDocId: docId,
      notes: data["notes"] || "",
      remarks: data["invNumber"] || "",
      docUploadType: "agency",
    };

    await dispatch(updateTimeLogInvoice(tmObj));
    handleInvShowHide("save");
    getAlert("Invoice Uploaded Successfully", "", "success");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isProcessing) return;
    setIsProcessing(true);
    try {
      await doSubmit();
    } catch (err) {
      console.error(err);
    } finally {
      setIsProcessing(false);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const droppedFiles = Array.from(e.dataTransfer.files);
    const docs = [
      ...documents,
      ...droppedFiles.map((file) => ({
        name: file.name,
        type: file.type,
        file,
        size: file.size,
      })),
    ];
    setDocuments(docs);
  };

  const onFileChange = (event) => {
    const selectedFiles = Array.from(event.target.files);
    const docs = [
      ...documents,
      ...selectedFiles.map((file) => ({
        name: file.name,
        type: file.type,
        file,
        size: file.size,
      })),
    ];
    setDocuments(docs);
  };

  const handleFileRemove = (item) => {
    const updatedDocuments = documents.filter((doc) => doc !== item);
    setDocuments(updatedDocuments);
  };

  const { invShowHide, handleInvShowHide } = props;

  const formatFileSize = (bytes) => {
    if (bytes === undefined || bytes === null) return "0 Bytes";
    if (bytes >= 1048576) {
      return `${(bytes / 1048576).toFixed(2)} MB`;
    }
    return `${(bytes / 1024).toFixed(1)} KB`;
  };

  return (
    <>
      <style dangerouslySetInnerHTML={{
        __html: `
        /* Ensure the modal and backdrop are on top of other elements */
        .modal-backdrop {
          z-index: 1080 !important;
        }
        .modal {
          z-index: 1090 !important;
          overflow-y: hidden !important;
        }

        /* Glassmorphic backdrop filter and blur */
        .modal-backdrop.show {
          backdrop-filter: blur(8px) !important;
          -webkit-backdrop-filter: blur(8px) !important;
          background-color: rgba(15, 23, 42, 0.45) !important;
          opacity: 1 !important;
        }

        /* Spring-like transition for scale-in animation */
        .modal.fade .wf-pay-modal.modal-dialog {
          transform: scale(0.95) !important;
          transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) !important;
        }
        .modal.show .wf-pay-modal.modal-dialog {
          transform: scale(1) !important;
        }

        .wf-pay-modal {
          --task-accent: #2563eb; /* Primary Blue */
          --task-soft: #f8fafc;
          max-width: 760px !important;
          width: 100% !important;
        }

        .wf-pay-modal .modal-content {
          border-radius: 16px !important;
          border: none !important;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
          overflow: hidden !important;
          background: #ffffff !important;
        }

        .wf-pay-modal .modal-header {
          position: relative !important;
          display: block !important;
          padding: 22px 28px 18px 32px !important;
          background: linear-gradient(90deg, var(--task-soft) 0%, rgba(255,255,255,0.98) 54%, #ffffff 100%) !important;
          border-bottom: 1px solid #edf2f7 !important;
          overflow: hidden !important;
        }

        .wf-pay-modal .modal-header::before {
          content: "" !important;
          position: absolute !important;
          top: 0 !important;
          left: 0 !important;
          bottom: 0 !important;
          width: 4px !important;
          background: var(--task-accent) !important;
        }

        .wf-pay-modal .rt-header-shell {
          display: flex !important;
          flex-direction: column !important;
          gap: 12px !important;
          width: 100% !important;
        }

        .wf-pay-modal .rt-header-top {
          display: flex !important;
          justify-content: space-between !important;
          align-items: flex-start !important;
          gap: 18px !important;
          width: 100% !important;
        }

        .wf-pay-modal .rt-header-main {
          display: flex !important;
          align-items: center !important;
          gap: 14px !important;
          min-width: 0 !important;
          flex: 1 1 auto !important;
        }

        .wf-pay-modal .rt-header-copy {
          display: flex !important;
          flex-direction: column !important;
          gap: 4px !important;
          min-width: 0 !important;
          padding-top: 2px !important;
        }

        .wf-pay-modal .rt-modal-title {
          display: inline-flex !important;
          align-items: center !important;
          margin: 0 !important;
          color: #0f172a !important;
          font-size: 18px !important;
          font-weight: 850 !important;
          line-height: 1.2 !important;
          min-width: 0 !important;
        }

        .wf-pay-modal .rt-header-icon {
          width: 48px !important;
          height: 48px !important;
          min-height: 48px !important;
          border-radius: 10px !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          color: var(--task-accent) !important;
          background: #ffffff !important;
          border: 1px solid var(--task-accent) !important;
          box-shadow: 0 8px 18px -12px rgba(15,23,42,0.28) !important;
          font-size: 18px !important;
          flex-shrink: 0 !important;
        }

        .wf-pay-modal .rt-modal-title-text {
          display: inline-flex !important;
          align-items: center !important;
          gap: 10px !important;
          min-width: 0 !important;
          flex-wrap: wrap !important;
        }

        .wf-pay-modal .rt-modal-title-badge {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          padding: 4px 10px !important;
          border-radius: 999px !important;
          font-size: 10px !important;
          font-weight: 800 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.02em !important;
          background: #eff6ff !important;
          color: var(--task-accent) !important;
          border: 1px solid rgba(37, 99, 235, 0.1) !important;
        }

        .wf-pay-modal .rt-modal-desc {
          display: inline-flex !important;
          align-items: center !important;
          gap: 6px !important;
          color: #64748b !important;
          font-weight: 500 !important;
          line-height: 1.4 !important;
          font-size: 12px !important;
        }
        .wf-pay-modal .rt-modal-desc i {
          color: var(--task-accent) !important;
        }

        .wf-pay-modal .rt-action-btn {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 36px !important;
          height: 36px !important;
          padding: 0 !important;
          font-size: 12px !important;
          font-weight: 700 !important;
          color: #64748b !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 8px !important;
          cursor: pointer !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05) !important;
          outline: none !important;
        }
        .wf-pay-modal .rt-action-btn:hover {
          color: #0f172a !important;
          border-color: #94a3b8 !important;
          background: #f8fafc !important;
          transform: translateY(-1px) !important;
          box-shadow: 0 4px 12px rgba(15, 23, 42, 0.05) !important;
        }
        .wf-pay-modal .rt-action-btn i {
          font-size: 11px !important;
          color: #94a3b8 !important;
        }
        .wf-pay-modal .rt-action-btn:hover i {
          color: #ef4444 !important;
        }

        .wf-pay-modal .modal-body {
          padding: 28px !important;
          background: #ffffff !important;
          max-height: calc(100vh - 250px) !important;
          overflow-y: auto !important;
        }

        .wf-pay-modal .form-group {
          margin-bottom: 20px !important;
        }

        .wf-pay-modal label {
          display: block !important;
          font-size: 12.5px !important;
          font-weight: 800 !important;
          color: #1e3a8a !important;
          margin-bottom: 8px !important;
          text-transform: uppercase !important;
          letter-spacing: 0.05em !important;
        }

        .wf-pay-modal .form-control {
          background: #ffffff !important;
          border: 1.5px solid #cbd5e1 !important;
          border-radius: 10px !important;
          padding: 10px 14px !important;
          font-size: 14px !important;
          font-weight: 600 !important;
          color: #1e293b !important;
          transition: all 0.2s ease !important;
          box-shadow: inset 0 2px 4px rgba(15, 23, 42, 0.02) !important;
          outline: none !important;
        }

        .wf-pay-modal .form-control:focus {
          border-color: #2563eb !important;
          box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12), inset 0 2px 4px rgba(15, 23, 42, 0.02) !important;
        }

        .wf-pay-modal textarea.form-control {
          min-height: 80px !important;
          resize: vertical !important;
        }

        .wf-pay-modal input[name="invNumber"] {
          padding-left: 36px !important;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%2364748b'%3E%3Cpath d='M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z'/%3E%3C/svg%3E") !important;
          background-repeat: no-repeat !important;
          background-position: 12px center !important;
          background-size: 16px 16px !important;
        }

        /* Dropzone Style */
        .wf-pay-modal .drop-zone {
          border: 2px dashed #cbd5e1 !important;
          border-radius: 12px !important;
          padding: 32px 24px !important;
          background: #f8fafc !important;
          cursor: pointer !important;
          transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
          display: flex !important;
          flex-direction: column !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 12px !important;
        }
        .wf-pay-modal .drop-zone:hover {
          border-color: #2563eb !important;
          background: #eff6ff !important;
          box-shadow: 0 4px 12px rgba(37, 99, 235, 0.05) !important;
        }
        .wf-pay-modal .drop-zone.dragging {
          border-color: #2563eb !important;
          background: #eff6ff !important;
          transform: scale(1.01) !important;
        }
        .wf-pay-modal .drop-icon-wrapper {
          width: 48px !important;
          height: 48px !important;
          border-radius: 50% !important;
          background: #ffffff !important;
          border: 1px solid #e2e8f0 !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          color: #64748b !important;
          font-size: 20px !important;
          transition: all 0.25s ease !important;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05) !important;
        }
        .wf-pay-modal .drop-zone:hover .drop-icon-wrapper {
          color: #2563eb !important;
          border-color: rgba(37, 99, 235, 0.2) !important;
          transform: translateY(-2px) !important;
          box-shadow: 0 8px 12px -3px rgba(37, 99, 235, 0.15) !important;
        }
        .wf-pay-modal .drop-text-primary {
          font-size: 14px !important;
          font-weight: 700 !important;
          color: #334155 !important;
        }
        .wf-pay-modal .drop-text-secondary {
          font-size: 12px !important;
          font-weight: 500 !important;
          color: #64748b !important;
        }

        /* File Previews */
        .wf-pay-modal .file-preview {
          margin-top: 16px !important;
          display: flex !important;
          flex-direction: column !important;
          gap: 10px !important;
        }
        .wf-pay-modal .file-preview-item {
          display: flex !important;
          align-items: center !important;
          justify-content: space-between !important;
          padding: 12px 16px !important;
          background: #ffffff !important;
          border: 1px solid #e2e8f0 !important;
          border-radius: 10px !important;
          transition: all 0.2s ease !important;
        }
        .wf-pay-modal .file-preview-item:hover {
          border-color: #cbd5e1 !important;
          background: #f8fafc !important;
        }
        .wf-pay-modal .file-info {
          display: flex !important;
          align-items: center !important;
          gap: 12px !important;
          min-width: 0 !important;
        }
        .wf-pay-modal .file-icon {
          font-size: 18px !important;
          color: #3b82f6 !important;
        }
        .wf-pay-modal .file-details {
          display: flex !important;
          flex-direction: column !important;
          gap: 2px !important;
          min-width: 0 !important;
        }
        .wf-pay-modal .file-name {
          font-size: 13px !important;
          font-weight: 700 !important;
          color: #334155 !important;
          white-space: nowrap !important;
          overflow: hidden !important;
          text-overflow: ellipsis !important;
        }
        .wf-pay-modal .file-size {
          font-size: 11px !important;
          font-weight: 600 !important;
          color: #64748b !important;
        }
        .wf-pay-modal .file-remove-btn {
          width: 32px !important;
          height: 32px !important;
          border-radius: 6px !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          color: #94a3b8 !important;
          background: transparent !important;
          border: none !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
          outline: none !important;
        }
        .wf-pay-modal .file-remove-btn:hover {
          color: #ef4444 !important;
          background: #fef2f2 !important;
        }

        .wf-pay-modal .modal-footer {
          background: #f8fafc !important;
          border-top: 1px solid #edf2f7 !important;
          padding: 16px 24px !important;
          display: flex !important;
          justify-content: flex-end !important;
          gap: 12px !important;
        }

        .wf-pay-modal .wf-modal-footer-close-btn {
          display: inline-flex !important;
          align-items: center !important;
          gap: 7px !important;
          padding: 9px 20px !important;
          font-size: 13px !important;
          font-weight: 700 !important;
          color: #475569 !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 8px !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
          outline: none !important;
        }
        .wf-modal-footer-close-btn:hover {
          background: #f8fafc !important;
          color: #0f172a !important;
        }

        .wf-pay-modal .wf-btn-save {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 8px !important;
          height: 38px !important;
          padding: 0 24px !important;
          border-radius: 8px !important;
          border: 1px solid rgba(37, 99, 235, 0.15) !important;
          background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%) !important;
          color: #ffffff !important;
          font-size: 13.5px !important;
          font-weight: 700 !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
          outline: none !important;
          box-shadow: 0 4px 12px rgba(37, 99, 235, 0.15) !important;
        }
        .wf-pay-modal .wf-btn-save:hover {
          background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%) !important;
          transform: translateY(-1px) !important;
          box-shadow: 0 6px 16px rgba(37, 99, 235, 0.2) !important;
        }
        .wf-pay-modal .wf-btn-save:active {
          transform: scale(0.97) !important;
        }
        .wf-pay-modal .wf-btn-save:disabled {
          background: #cbd5e1 !important;
          border-color: #cbd5e1 !important;
          color: #94a3b8 !important;
          cursor: not-allowed !important;
          box-shadow: none !important;
          transform: none !important;
        }
      `}} />
      <Modal show={invShowHide} size="xl" dialogClassName="wf-pay-modal" centered>
        <Modal.Header>
          <div className="rt-header-shell">
            <div className="rt-header-top">
              <div className="rt-header-main">
                <i className="rt-header-icon fa fa-file-text-o" aria-hidden="true" />
                <div className="rt-header-copy">
                  <h2 className="rt-modal-title">
                    <span className="rt-modal-title-text">
                      <span>Upload Invoice</span>
                      <span className="rt-modal-title-badge">Invoice</span>
                    </span>
                  </h2>
                  <span className="rt-modal-desc">
                    <i className="fa fa-info-circle" aria-hidden="true" /> Enter invoice details, upload your file, and add notes.
                  </span>
                </div>
              </div>
              <button
                type="button"
                className="rt-action-btn"
                onClick={() => handleInvShowHide("")}
                title="Close"
              >
                <i className="fa fa-times" aria-hidden="true" />
              </button>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body className="border-0">
          <div className="row">
            <div className="col-md-12">{renderInput("invNumber", "Invoice Number")}</div>

            <div className="col-md-12 form-group">
              <label className="form-control-label">Upload Invoice File</label>
              <div
                className={`drop-zone ${isDragging ? "dragging" : ""}`}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
                onClick={() => fileInputRef.current && fileInputRef.current.click()}
              >
                <div className="drop-icon-wrapper">
                  <i className="fa fa-cloud-upload" aria-hidden="true"></i>
                </div>
                <span className="drop-text-primary">
                  {isDragging ? "Drop files here..." : "Drag & drop invoice here, or click to select"}
                </span>
                <span className="drop-text-secondary">
                  Supports PDF, DOCX, PNG, JPG up to 10MB
                </span>
                <input
                  type="file"
                  ref={fileInputRef}
                  onChange={onFileChange}
                  multiple
                  hidden
                />
              </div>

              {documents.length > 0 && (
                <div className="file-preview">
                  {documents.map((file, index) => (
                    <div key={index} className="file-preview-item">
                      <div className="file-info">
                        <i className="fa fa-file-pdf-o file-icon" aria-hidden="true" />
                        <div className="file-details">
                          <span className="file-name">{file.name}</span>
                          <span className="file-size">{formatFileSize(file.size)}</span>
                        </div>
                      </div>
                      <button
                        type="button"
                        className="file-remove-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleFileRemove(file);
                        }}
                        title="Remove file"
                      >
                        <i className="fa fa-trash-o" aria-hidden="true"></i>
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div className="col-md-12">{renderTextArea("notes", "Notes")}</div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="wf-modal-footer-close-btn"
            onClick={() => handleInvShowHide("")}
          >
            <i className="fa fa-times" aria-hidden="true"></i> Close
          </button>
          <button
            className="wf-btn-save"
            onClick={handleSubmit}
            disabled={isProcessing}
          >
            <i
              className={`fa ${isProcessing ? "fa-spinner fa-spin" : "fa-paper-plane"}`}
              aria-hidden="true"
            ></i>{" "}
            Save
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default UploadInvoice;
